import {
  GET_ALL_INVOICES_START,
  GET_ALL_INVOICES_COMPLETE,
  GET_ALL_INVOICES_ERROR,
  DOWNLOAD_REPORT_START,
  DOWNLOAD_REPORT_COMPLETE,
  DOWNLOAD_REPORT_ERROR,
  DOWNLOAD_INVOICE_START,
  DOWNLOAD_INVOICE_COMPLETE,
  DOWNLOAD_INVOICE_ERROR,
  MAKE_MONTHLY_PAYMENT_START,
  MAKE_MONTHLY_PAYMENT_COMPLETE,
  MAKE_MONTHLY_PAYMENT_ERROR,
  CLEAR_ALL_INVOICES_ERROR,
  CLEAR_STRIPE_REDIRECT_URL,
  FETCH_ALL_PAYMENT_TRANSACTIONS_START,
  FETCH_ALL_PAYMENT_TRANSACTIONS_COMPLETE,
  FETCH_ALL_PAYMENT_TRANSACTIONS_ERROR,
  ADD_FUNDS_TO_BANK_START,
  ADD_FUNDS_TO_BANK_COMPLETE,
  ADD_FUNDS_TO_BANK_ERROR,
  CLEAR_ALL_TRANSACTION_ERROR,
  CLEAR_STRIPE_TRANSACTION_REDIRECT_URL,
} from './actions';
import { LOGOUT } from '../login/actions';

let initialState = {
  getInvociesError: undefined,
  invoiceList: undefined,
  isGetInvoicesStarted: false,
  totalInvoicesRecords: 0,
  totalInvoicePages: 0,
  downloadReportError: undefined,
  isDownloadReportStarted: false,
  downloadInvoiceError: undefined,
  isDownloadInvoiceStarted: false,
  monthlyPaymentError: undefined,
  isMonthlyPaymentStarted: false,
  stripeRedirectUrl: undefined,
};

const reducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_ALL_INVOICES_START:
      return {
        ...state,
        isGetInvoicesStarted: true,
        getInvociesError: undefined,
        invoiceList: undefined,
      };
    case GET_ALL_INVOICES_COMPLETE:
      return {
        ...state,
        invoiceList: payload.data,
        totalInvoicesRecords: payload.totalRecords,
        totalInvoicePages: payload.totalPages,
        isGetInvoicesStarted: false,
        getInvociesError: undefined,
      };
    case GET_ALL_INVOICES_ERROR:
      return {
        ...state,
        getInvociesError: payload.error,
        isGetInvoicesStarted: false,
        invoiceList: undefined,
      };
    case DOWNLOAD_REPORT_START:
      return {
        ...state,
        isDownloadReportStarted: true,
        downloadReportError: undefined,
      };
    case DOWNLOAD_REPORT_COMPLETE:
      return {
        ...state,
        isDownloadReportStarted: false,
        downloadReportError: undefined,
      };
    case DOWNLOAD_REPORT_ERROR:
      return {
        ...state,
        downloadReportError: payload.error,
        isDownloadReportStarted: false,
      };
    case DOWNLOAD_INVOICE_START:
      return {
        ...state,
        isDownloadInvoiceStarted: true,
        downloadInvoiceError: undefined,
      };
    case DOWNLOAD_INVOICE_COMPLETE:
      return {
        ...state,
        isDownloadInvoiceStarted: false,
        downloadInvoiceError: undefined,
      };
    case DOWNLOAD_INVOICE_ERROR:
      return {
        ...state,
        downloadInvoiceError: payload.error,
        isDownloadInvoiceStarted: false,
      };
    case MAKE_MONTHLY_PAYMENT_START:
      return {
        ...state,
        isMonthlyPaymentStarted: true,
        monthlyPaymentError: undefined,
        stripeRedirectUrl: undefined,
      };
    case MAKE_MONTHLY_PAYMENT_COMPLETE:
      return {
        ...state,
        isMonthlyPaymentStarted: false,
        monthlyPaymentError: undefined,
        stripeRedirectUrl: payload.data,
      };
    case MAKE_MONTHLY_PAYMENT_ERROR:
      return {
        ...state,
        monthlyPaymentError: payload.error,
        isMonthlyPaymentStarted: false,
        stripeRedirectUrl: undefined,
      };
    case FETCH_ALL_PAYMENT_TRANSACTIONS_START:
      return {
        ...state,
        isFetchAllTransactionsStarted: true,
        fetchAllTransactionsError: undefined,
        transactionsList: undefined,
      };
    case FETCH_ALL_PAYMENT_TRANSACTIONS_COMPLETE:
      return {
        ...state,
        transactionsList: payload.data,
        totalTransactionsRecords: payload.totalRecords,
        totalTransactionsPages: payload.totalPages,
        isFetchAllTransactionsStarted: false,
        fetchAllTransactionsError: undefined,
      };
    case FETCH_ALL_PAYMENT_TRANSACTIONS_ERROR:
      return {
        ...state,
        fetchAllTransactionsError: payload.error,
        isFetchAllTransactionsStarted: false,
        transactionsList: undefined,
      };
    case ADD_FUNDS_TO_BANK_START:
      return {
        ...state,
        isAddFundsToBankStarted: true,
        fundTransactionError: undefined,
        stripeFundsRedirectUrl: undefined,
      };
    case ADD_FUNDS_TO_BANK_COMPLETE:
      return {
        ...state,
        isAddFundsToBankStarted: false,
        fundTransactionError: undefined,
        stripeFundsRedirectUrl: payload.data,
      };
    case ADD_FUNDS_TO_BANK_ERROR:
      return {
        ...state,
        fundTransactionError: payload.error,
        isAddFundsToBankStarted: false,
        stripeFundsRedirectUrl: undefined,
      };
    case CLEAR_STRIPE_TRANSACTION_REDIRECT_URL:
      return {
        ...state,
        stripeFundsRedirectUrl: undefined,
      };
    case CLEAR_ALL_TRANSACTION_ERROR:
      return {
        ...state,
        fundTransactionError: undefined,
        downloadInvoiceError: undefined,
        downloadReportError: undefined,
        getInvociesError: undefined,
      };
    case CLEAR_STRIPE_REDIRECT_URL:
      return {
        ...state,
        stripeRedirectUrl: undefined,
      };
    case CLEAR_ALL_INVOICES_ERROR:
      return {
        ...state,
        monthlyPaymentError: undefined,
        fetchAllTransactionsError: undefined,
        getInvociesError: undefined,
        downloadReportError: undefined,
        downloadInvoiceError: undefined,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
